var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03153 22L4 12H0V8H4V5.5C4 1.7886 6.29832 0 9.60914 0C11.1951 0 12.5581 0.11807 12.9553 0.17085V4.04948L10.6591 4.05052C8.85845 4.05052 8.50981 4.90614 8.50981 6.16171V8H13.75L11.75 12H8.50981V22H4.03153Z",
    fill: "#35383F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.fdf4fdadd11ab44a4014c5d28aa91577.svg";
export { ForwardRef as ReactComponent };